/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import DelayHourglass from './delay-hourglass.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <DelayHourglass {...validProps} />;
}
SvgComponent.iconName = 'delay-hourglass';

export const DelayHourglassIcon = svgIconWrapper(SvgComponent);
